import React from 'react';
import classNames from 'classnames';

import VideoMediafilesPreviewItemSkeleton from 'application/components/VideoMediafilePreviewItemSkeleton';
import styles from './index.module.scss';
import ItemContent from '../ItemContent';
import EmenuItemContent from '../EmenuItemContent';
import { IVideoStreamItem } from '../../types';

export type StreamPreviewItemProps = {
  file?: IVideoStreamItem;
  className?: string;
  onSetDuration: (id: string, duration: number) => void;
  onRemoveMediafile: (id: string) => void;
  onCopyMediafile: (id: string) => void;
  isBlockedDurationEdit?: boolean;
};

const PreviewItem: React.FC<StreamPreviewItemProps> = ({
  file,
  className,
  onSetDuration,
  onRemoveMediafile,
  onCopyMediafile,
  isBlockedDurationEdit,
}) => {
  const renderItem = () => {
    if (!file) return <VideoMediafilesPreviewItemSkeleton />;

    if (file.itemType === 'emenu') {
      return (
        <EmenuItemContent
          title={file.title}
          playDuration={file.playDuration}
          generationDuration={file.generationDuration}
        />
      );
    }

    return (
      <ItemContent
        imgLink={file.previewUrl}
        title={file.title}
        duration={file.duration}
        extension={file.sourcefiles ? file?.sourcefiles[0]?.extension : undefined}
        playDuration={file.playDuration}
        onSetDuration={onSetDuration}
        id={file.id}
        onRemoveMediafile={onRemoveMediafile}
        onCopyMediafile={onCopyMediafile}
        isBlockedDurationEdit={isBlockedDurationEdit}
      />
    );
  };

  return <div className={classNames(styles.StreamPreviewItem, className)}>{renderItem()}</div>;
};

export default PreviewItem;
